import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	inputinput: { padding: 0, input: { textAlign: 'center' } },
	numberInputRoot: {
		width: '130px',
		display: 'flex',
		flexDirection: 'row',
		gap: theme.spacing.tiny,
	},
	increment: {
		order: 1,
	},
}));
